'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _sizes = require('HubStyleTokens/sizes');

var _misc = require('HubStyleTokens/misc');

var _Styles = require('../../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Heading4 = (0, _styledComponents2.default)(_Heading2.default).withConfig({
  displayName: 'H4__Heading4'
})(_templateObject, _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT4], (0, _Styles.setFontSize)(_sizes.HEADING4));

Heading4.propTypes = _extends({}, _Heading2.default.propTypes);

Heading4.defaultProps = _extends({}, _Heading2.default.defaultProps);

var H4 = Heading4.withComponent('h4');

exports.default = H4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/elements/headings/H4.js
// module id = 497
// module chunks = 0